// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1szG9","inputDescription":"styles_inputDescription__9xxZs"};